import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, MapPin } from 'lucide-react';
import { stories } from '../mock';

const Stories = () => {
  const [i, setI] = useState(0);
  const s = stories[i];
  const next = () => setI((i + 1) % stories.length);
  const prev = () => setI((i - 1 + stories.length) % stories.length);

  return (
    <section id="stories" className="py-24 lg:py-32 bg-white relative overflow-hidden border-y border-black/5">
      <div className="brush-swash w-72 h-16 top-24 right-0" />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] rounded-[2rem] overflow-hidden shadow-xl">
              <img
                key={s.image}
                src={s.image}
                alt={s.name}
                className="absolute inset-0 w-full h-full object-cover transition-opacity duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0E1112]/70 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 text-white">
                <span className="hl-box hl-purple font-serif text-3xl font-bold">{s.name}</span>
                <div className="flex items-center gap-1 text-sm mt-3 text-white/90">
                  <MapPin className="w-3.5 h-3.5" />
                  {s.location} • {s.role}
                </div>
              </div>
            </div>
            <div className="absolute -top-4 -left-6 w-40 h-16 bg-[#F1D3B6] rounded-[50%] -rotate-12 -z-0 opacity-70" />
          </div>

          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.25em] font-semibold text-[#6e12ed] mb-4">
              Members’ Stories
            </div>
            <h2 className="font-serif text-4xl lg:text-6xl font-bold text-[#0E1112] leading-[1.02]">
              Voices of<br />
              our <span className="hl-box hl-cyan">community</span>.
            </h2>

            <blockquote className="mt-8 font-serif text-2xl lg:text-[28px] text-[#0E1112] leading-[1.35]">
              <span className="text-[#6e12ed] mr-1">“</span>{s.quote}<span className="text-[#6e12ed] ml-1">”</span>
            </blockquote>
            <div className="mt-5 text-neutral-600 font-semibold">
              — {s.name}, {s.role}
            </div>

            <div className="mt-10 flex items-center gap-4">
              <button
                aria-label="Previous story"
                onClick={prev}
                className="w-12 h-12 rounded-full border-2 border-[#0E1112] flex items-center justify-center hover:bg-[#0E1112] hover:text-white transition-colors"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              <button
                aria-label="Next story"
                onClick={next}
                className="w-12 h-12 rounded-full border-2 border-[#0E1112] flex items-center justify-center hover:bg-[#0E1112] hover:text-white transition-colors"
              >
                <ChevronRight className="w-5 h-5" />
              </button>
              <div className="ml-2 flex gap-2">
                {stories.map((_, idx) => (
                  <button
                    key={idx}
                    aria-label={`Story ${idx + 1}`}
                    onClick={() => setI(idx)}
                    className={`h-2 rounded-full transition-all ${
                      idx === i ? 'w-8 bg-[#6e12ed]' : 'w-2 bg-black/20'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stories;
